import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="mx-auto h-24 w-24 text-6xl">🔍</div>
          <h1 className="mt-6 text-6xl font-bold text-gray-900">404</h1>
          <h2 className="mt-2 text-2xl font-semibold text-gray-700">
            Admin Page Not Found
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            The admin page you're looking for doesn't exist.
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-blue-600 hover:text-blue-500 font-medium"
          >
            ← Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminNotFound;
